import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import type { ReactNode } from 'react';

import { Footer } from '../../components/layout/Footer';
import { TopNav } from '../../components/layout/TopNav';

import { legalPageStyles as styles } from './LegalPage.styles';

interface LegalPageProps {
  title: string;
  /** e.g. "Last updated: September 2025". */
  updated?: string;
  children: ReactNode;
}

/** Shared shell for the legal pages (Privacy Policy, Terms & Conditions). */
export function LegalPage({ title, updated, children }: LegalPageProps) {
  return (
    <Box sx={styles.root}>
      <TopNav />

      <Box component="main" sx={styles.main}>
        <Box sx={styles.content}>
          <Typography component="h1" sx={styles.title}>
            {title}
          </Typography>
          {updated && <Typography sx={styles.updated}>{updated}</Typography>}
          <Box sx={styles.body}>{children}</Box>
        </Box>
      </Box>

      <Footer />
    </Box>
  );
}
